import {useCallback, useEffect, useState} from 'react';

import assign from 'lodash/assign';
import pick from 'lodash/pick';

import {
  dataChangesPublisher,
  procedureDetailSource,
  procedureVersionSource,
  userDataSource,
} from '../../demo_fixtures';
import {EventEmitter} from '../../EventEmmiter';
import {nowISOString, waitAndReturn} from '../../utils';

export const PROCEDURE_RTK_TAGS = {
  TAGS: 'PROCEDURE',
  HASHID: 'PROCEDUREHASHID',
};

let user = userDataSource;
let procedure = procedureDetailSource;
let version = procedureVersionSource;

export const useProcedureById = () => ({});

const approveProcedureVersion = () => {
  assign(version, {
    approved_by: pick(user, ['id', 'is_deleted', 'url', 'name', 'email']),
    approved_at: nowISOString(),
    modified_at: nowISOString(),
    is_current: true,
  });
  assign(procedure, {
    approved_by: pick(user, ['id', 'is_deleted', 'url', 'name', 'email']),
    approved_at: nowISOString(),
    modified_at: nowISOString(),
    edited_at: nowISOString(),
    name: version.name,
    current_version: pick(version, ['id', 'url', 'html_url']),
  });

  dataChangesPublisher.publish('procedure', procedure);
  return waitAndReturn(version);
};
export const useApproveProcedureVersion = () => [approveProcedureVersion];
export const useProcedures = () => ({});
export const useUpdateProcedure = () => {
  const [isLoading, setIsLoading] = useState(false);

  const update = (body) => {
    const update = () => {
      setIsLoading(true);
      assign(procedure, body);
      eventEmitter.emit('procedureUpdate', {...procedure});
      return waitAndReturn(procedure).then(() => setIsLoading(false));
    };
    const promise = update();
    return {unwrap: () => promise};
  };
  return [update, {isLoading}];
};
export const useUpdateProcedureVersion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const updateVersion = useCallback((body) => {
    const update = () => {
      setIsLoading(true);
      assign(version, body);
      eventEmitter.emit('versionUpdate', {...version});
      return waitAndReturn(version).then(() => setIsLoading(false));
    };
    const promise = update();
    return {unwrap: () => promise};
  }, []);
  return [updateVersion, {data: version, isLoading, isError: false}];
};

export const useProcedureVersionById = () => {
  const [data, setData] = useState(version);
  useEffect(() => {
    const onUpdate = (updated) => setData({...updated});
    eventEmitter.on('versionUpdate', onUpdate);
    return () => eventEmitter.off('versionUpdate', onUpdate);
  }, []);
  return {
    data: data,
    refetch: () => setData(version),
  };
};
export const useProcedureByHashid = () => {
  const [data, setData] = useState(procedure);

  useEffect(() => {
    const onUpdate = (updated) => setData({...updated});
    eventEmitter.on('procedureUpdate', onUpdate);

    return () => eventEmitter.off('procedureUpdate', onUpdate);
  }, []);
  return {
    data,
    refetch: () => setData(procedure),
  };
};

export const eventEmitter = new EventEmitter();
